import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActionDisplayResponse, ActionRequest, ActionTypeOptions} from '../../../_models/action.model';
import {FormControl, FormGroup} from '@angular/forms';
import {GenericOption, WorkTypeService} from '@cas-hub/acabim-common-client';
import {ActionService} from '../../../_services/action.service';
import {CategoryResponse, SubCategory, WorkType} from '@cas-hub/acabim-common-client/lib/_models/work-type.model';

@Component({
  selector: 'acabim-admin-action-detail',
  templateUrl: './action-detail.component.html',
  styleUrls: ['./action-detail.component.scss']
})
export class ActionDetailComponent implements OnInit {

  hasWork = false;
  isLoading = true;
  mode = 'add';
  parcel: ActionRequest | null = null;
  priorityTypes: GenericOption[] = [ {value: 1, label: 'Low'}, {value: 2, label: 'Medium'}, {value: 3, label: 'High'}];
  selectedAction: ActionDisplayResponse | null = null;
  stage = 1;
  types: ActionTypeOptions | null = null;
  workTypeId = 0;
  workCategories: CategoryResponse[] = [];
  workTasks: SubCategory[] = [];
  workTypes: WorkType[] = [];
  @Input() set setDetails(value: ActionDisplayResponse | null) {
    this.stage = 1;
    console.dir(value);
    this.actionService.getTypes().subscribe(data => {
      console.dir(data);
      this.types = data;
      if (value) {
        this.mode = 'update';
        this.selectedAction = value;
        this.initForm(value);
      } else {
        this.mode = 'add';
      }
      this.formWatch();
      this.isLoading = false;
    });
  }
  @Output() close: EventEmitter<string> = new EventEmitter<string>();

  actionForm: FormGroup = new FormGroup({
    name: new FormControl(),
    description: new FormControl(),
    entityType: new FormControl(),
    entitySubType: new FormControl(),
    targetType: new FormControl(),
    category: new FormControl(),
    subCategory: new FormControl(),
    repeating: new FormControl(),
    priority: new FormControl(),
    expenseType: new FormControl(),
    workOrderType: new FormControl(),
    workOrderCategory: new FormControl(),
    workOrderTask: new FormControl(),
    status: new FormControl(true)
  });

  constructor(
      private readonly actionService: ActionService,
      private readonly workTypeService: WorkTypeService
  ) { }

  ngOnInit(): void {}

  initForm(data: ActionDisplayResponse) {
    if (this.actionForm) {
      if(data.target_type === 'WorkOrder') {
        this.hasWork = true;
      } else {
        this.hasWork = true;
      }
      this.actionForm.get('name')?.setValue(data.name);
      this.actionForm.get('description')?.setValue(data.description);
      this.actionForm.get('entityType')?.setValue(data.entity_type);
      this.actionForm.get('entitySubType')?.setValue(data.entity_type_subset);
      this.actionForm.get('targetType')?.setValue(data.target_type);
      this.actionForm.get('category')?.setValue(data.category);
      this.actionForm.get('subCategory')?.setValue(data.sub_category);
      this.actionForm.get('expenseType')?.setValue(data.expense_type);
      this.actionForm.get('workOrderType')?.setValue(data.work_order_type.id);
      this.actionForm.get('workOrderCategory')?.setValue(data.work_order_category.id);
      this.actionForm.get('workOrderTask')?.setValue(data.work_order_task.id);
      this.actionForm.get('repeating')?.setValue(data.repeating === 1);
      this.actionForm.get('priority')?.setValue(data.priority);
      this.actionForm.get('status')?.setValue(data.status === 1);
    }
  }

  formWatch(): void {
    if (this.actionForm) {
      this.actionForm.get('targetType')?.valueChanges.subscribe(val => {
            console.dir(val);
            if(val === 'WorkOrder') {
              this.hasWork = true;
            } else {
              this.hasWork = false;
            }
          }
      );
    }
  }

  handleWorkOrderActions(): void {
    this.workTypeId = 0;
    this.stage = 2;
    this.isLoading = true;
    this.workTypeService.getWorkTypes().subscribe(wts => {
      this.workTypes = wts;
      this.stage = 3;
      this.isLoading = false;
      console.dir(this.selectedAction);
      if (this.selectedAction && this.selectedAction.work_order_type.id) {
        this.setExistingWorkValues();
      }
      this.actionForm.get('workOrderType')?.valueChanges.subscribe(val => {
          console.dir(val);
          this.workCategories = [];
          this.workTasks = [];
          this.workTypeId = 0;
          if (val) {
            this.workTypeId = val;
            this.workTypeService.getCategories(val, {}).subscribe(cat => {
              console.dir(cat);
              this.workCategories = cat;
            });
          }
        }
      );
      this.actionForm.get('workOrderCategory')?.valueChanges.subscribe(val => {
        this.workTasks = [];
        console.dir(val);
        if (val && this.workTypeId > 0) {
          this.workTypeService.getSubCategories(this.workTypeId, val, {}).subscribe(tasks => {
            console.dir(tasks);
            this.workTasks = tasks;
          });
        }
      });
    })
  }

  private setExistingWorkValues(): void {
    if (this.selectedAction && this.selectedAction.work_order_type.id) {
      this.actionForm.get('workOrderType')?.setValue(this.selectedAction.work_order_type.id);
      this.workTypeId = this.selectedAction.work_order_type.id;
      this.isLoading = true;
      this.workTypeService.getCategories(this.selectedAction.work_order_type.id, {}).subscribe(cat => {
        this.workCategories = cat;
        this.isLoading = false;
        if (this.selectedAction && this.selectedAction.work_order_category.id) {
          this.actionForm.get('workOrderCategory')?.setValue(this.selectedAction.work_order_category.id);
          this.isLoading = true;
          this.workTypeService.getSubCategories(this.selectedAction.work_order_type.id, this.selectedAction.work_order_category.id, {}).subscribe(tasks => {
            this.isLoading = false;
            this.workTasks = tasks;
            if (this.selectedAction && this.selectedAction.work_order_task.id) {
              this.actionForm.get('workOrderTask')?.setValue(this.selectedAction.work_order_task.id);
            }
          });
        }
      });
    }
  }

  gather(): void {
    if(this.actionForm) {
      const WOType = this.actionForm.get('workOrderType')?.value;
      const WOCategory = this.actionForm.get('workOrderCategory')?.value;
      const WOTask = this.actionForm.get('workOrderTask')?.value;
      this.parcel = {
        name: this.actionForm.get('name')?.value,
        description: this.actionForm.get('description')?.value,
        entity_type: this.actionForm.get('entityType')?.value,
        entity_type_subset: this.actionForm.get('entitySubType')?.value,
        target_type: this.actionForm.get('targetType')?.value,
        category: this.actionForm.get('category')?.value,
        sub_category: this.actionForm.get('subCategory')?.value,
        repeating: this.actionForm.get('repeating')?.value ? 1 : 0,
        priority: this.actionForm.get('priority')?.value,
        expense_type: this.actionForm.get('expenseType')?.value,
        work_order_type: WOType > 0 ? WOType : null,
        work_order_category: WOCategory > 0 ? WOCategory : null,
        work_order_task: WOTask > 0 ? WOTask : null,
        status: this.actionForm.get('status')?.value ? 1 : 0
      };
    }

  }

  onSubmit(): void {
    this.gather();
    console.dir(this.parcel );
    if (this.mode === 'update' && this.parcel && this.selectedAction) {
      this.actionService.updateAction(this.selectedAction.id, this.parcel).subscribe(data => {
        console.dir(data);
        this.stage = 4;
      });
    } else if (this.mode === 'add' && this.parcel) {
      this.actionService.addAction(this.parcel).subscribe(data => {
        console.dir(data);
        this.stage = 4;
      });
    }
  }

  onComplete(): void {
    this.close.emit('completed');
  }

  onCancel(): void {
    this.close.emit('cancelled');
  }

}
